import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SecurityIcon from '@mui/icons-material/Security';
import axios from '../api/axios';
import DecorativeCubes from '../components/DecorativeCubes';

const PrivacyPolicyPage = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [lastUpdated, setLastUpdated] = useState(null);

  useEffect(() => {
    fetchPrivacyPolicy();
  }, []);

  const fetchPrivacyPolicy = async () => {
    try {
      const response = await axios.get('/privacy-policy/public');
      setContent(response.data.content || '');
      setLastUpdated(response.data.lastUpdated);
    } catch (error) {
      console.error('Error fetching privacy policy:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <>
        <Header />
        <Container maxWidth="lg" sx={{ py: 8 }}>
          <Typography variant="h5" align="center">
            Загрузка...
          </Typography>
        </Container>
        <Footer />
      </>
    );
  }

  return (
    <Box sx={{ position: 'relative' }}>
      <DecorativeCubes minCubes={6} maxCubes={10} />
      <Header />
      <Box sx={{ position: 'relative', overflow: 'hidden', minHeight: '100vh', backgroundColor: '#f9f9f9', zIndex: 2 }}>
        <Container maxWidth="lg" sx={{ py: 8, position: 'relative', zIndex: 2 }}>
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <SecurityIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
            <Typography
              variant="h2"
              sx={{
                mb: 2,
                fontWeight: 700,
                color: 'primary.main',
              }}
            >
              Политика конфиденциальности
            </Typography>
            {lastUpdated && (
              <Typography variant="body2" color="text.secondary">
                Последнее обновление: {new Date(lastUpdated).toLocaleDateString('ru-RU')}
              </Typography>
            )}
          </Box>

          <Paper
            elevation={3}
            sx={{
              p: 4,
              borderRadius: 4,
              backgroundColor: 'white',
            }}
          >
            <Box
              sx={{
                '& h1, & h2, & h3, & h4, & h5, & h6': {
                  marginTop: '1.5em',
                  marginBottom: '0.75em',
                  fontWeight: 'bold',
                  color: 'primary.main',
                },
                '& p': {
                  marginBottom: '1em',
                  lineHeight: 1.8,
                  color: 'text.primary',
                },
                '& ul, & ol': {
                  marginLeft: '20px',
                  marginBottom: '1em',
                  lineHeight: 1.8,
                },
                '& li': {
                  marginBottom: '0.5em',
                },
                '& a': {
                  color: 'primary.main',
                  textDecoration: 'underline',
                },
                '& strong': {
                  fontWeight: 700,
                },
              }}
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </Paper>

          <Box
            sx={{
              mt: 4,
              p: 3,
              backgroundColor: 'rgba(0, 172, 193, 0.1)',
              borderRadius: 2,
              borderLeft: '4px solid',
              borderColor: 'primary.main',
            }}
          >
            <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
              Вопросы по политике конфиденциальности?
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Если у вас есть вопросы о том, как мы обрабатываем ваши персональные данные, 
              свяжитесь с нами по телефону +7(918)213-03-33 или электронной почте wonderland_2023@mail.ru
            </Typography>
          </Box>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
};

export default PrivacyPolicyPage;
